import { render, staticRenderFns } from "./RightsFundError.vue?vue&type=template&id=54c9e91a"
import script from "./RightsFundError.vue?vue&type=script&lang=js"
export * from "./RightsFundError.vue?vue&type=script&lang=js"
import style0 from "./RightsFundError.vue?vue&type=style&index=0&id=54c9e91a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports